import React from 'react';
import {
  Button,
  Flex,
  Heading,
  Image,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

import { useHistory } from 'react-router-dom';
import { Header } from '../../components/Header';
import { Sidebar } from '../../components/Sidebar';

import notfoundDark from '../../assets/Notfound/error404_dark.svg';
import notfoundLight from '../../assets/Notfound/error404_light.svg';

const Notfound: React.FC = () => {
  const history = useHistory();
  const notfound = useColorModeValue(notfoundLight, notfoundDark);

  return (
    <Flex direction="column" h="100vh">
      <Header />

      <Flex w="100%" h="100%" mx="auto">
        <Sidebar />

        <Flex
          w="100%"
          h="100%"
          mx="auto"
          flexDir="column"
          align="center"
          justify="space-around"
          pt="16"
          px="6"
          pb="6"
        >
          <div>
            <Heading textAlign="center">
              404: A página que você está procurando não está aqui
            </Heading>
            <Text textAlign="center">
              Ou você tentou um caminho obscuro ou veio aqui por engano. Seja o
              que for, tente usar a navegação.
            </Text>
          </div>
          <Image w="400px" src={notfound} alt="404 - Notfound" />
          <Button
            variant="outline"
            fontSize="sm"
            onClick={() => history.push('/dashboard')}
          >
            Voltar para Visão Geral
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Notfound;
